import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDays,
  faCheckCircle,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";

const ProgramDetailsSection = ({
  title,
  tagline,
  highlights = [],
  description,
  duration,
  focusAreas = [],
  outcomes = [],
  images = [],
}) => {
    const [currentImage, setCurrentImage] = useState(0);

useEffect(() => {
  if (!images.length) return;

  const interval = setInterval(() => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  }, 3500);

  return () => clearInterval(interval);
}, [images]);
  return (
    <section className="py-24 px-6 bg-[#F7F1EA]">
      <div className="max-w-[1280px] mx-auto">

        {/* Heading */}
        <div className="text-center max-w-4xl mx-auto mb-16">

          <h1
            className="
              text-[clamp(42px,6vw,82px)]
              leading-[.95]
              tracking-[-0.05em]
              text-secondary
              mb-6
            "
          >
            {title}
          </h1>

          <h2 className="text-primary text-2xl font-semibold mb-8">
            {tagline}
          </h2>

          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {highlights.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-full px-5 py-2 shadow-sm border border-[#EFE6DB]"
              >
                {item}
              </div>
            ))}
          </div>



          <div className="inline-flex items-center gap-3 mt-8 px-6 py-3 rounded-full bg-[#FFF4E8] border border-[#F3DDC7]">
            <FontAwesomeIcon
              icon={faCalendarDays}
              className="text-primary"
            />

            <span className="font-semibold text-secondary">
              Duration : {duration}
            </span>
          </div>

        </div>

        {/* Focus + Images */}
        <div className="grid lg:grid-cols-2 gap-14 items-center mb-24">

          {/* Focus */}
          <div>

            <h3
              className="text-4xl text-secondary mb-8"
              style={{
                
              }}
            >
              Focus Areas
            </h3>

            <div className="space-y-5">

              {focusAreas.map((item, index) => (
                <div
                  key={index}
                  className="
                    flex
                    items-center
                    gap-4
                    bg-white
                    rounded-2xl
                    px-6
                    py-5
                    shadow-sm
                  "
                >
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="text-primary text-xl"
                  />

                  <span className="text-lg text-secondary">
                    {item}
                  </span>
                </div>
              ))}

            </div>

          </div>

          {/* Images */}
{/* Images */}

<div className="relative">

  <div
    className="
      absolute
      -top-10
      -right-10
      w-64
      h-64
      rounded-full
      bg-[#F28C28]/15
      blur-[100px]
    "
  />

  <div
    className="
      relative
      overflow-hidden
      rounded-[34px]
      shadow-[0_25px_70px_rgba(20,10,0,.12)]
      bg-white
    "
  >
    <img
      src={images[currentImage]}
      alt={title}
      className="
        w-full
        h-[520px]
        object-cover
        transition-all
        duration-700
      "
    />
  </div>

  {/* Dots */}

  <div className="flex justify-center gap-3 mt-6">
    {images.map((_, index) => (
      <button
        key={index}
        onClick={() => setCurrentImage(index)}
        className={`
          h-3
          rounded-full
          transition-all
          duration-300
          ${
            currentImage === index
              ? "w-8 bg-primary"
              : "w-3 bg-[#D8C8B8]"
          }
        `}
      />
    ))}
  </div>

</div>
        </div>

        {/* Outcomes */}

        <div>

          <div className="text-center mb-12">

            <h2
              className="text-[52px] text-secondary"
              style={{
                
              }}
            >
              Outcomes
            </h2>

          </div>

          <div className="grid md:grid-cols-2 gap-6">

            {outcomes.map((item, index) => (
              <div
                key={index}
                className="
                  bg-white
                  rounded-3xl
                  px-7
                  py-6
                  flex
                  gap-4
                  items-start
                  shadow-sm
                "
              >
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="text-primary mt-1 text-xl"
                />

                <span className="text-secondary text-lg">
                  {item}
                </span>
              </div>
            ))}

          </div>

        </div>

      </div>
    </section>
  );
};

export default ProgramDetailsSection;